import React, { useState, useEffect, useContext } from "react";
import {
    Logo,
    ThanksImg,
    BottomCenteringContainer,
    TableFlexContainer,
    LeftFlexGrow,
    MiddleFlexGrow,
    RightFlexGrow,
    TableContainer,
    BoldDescriptionText,
    MainContainer,
    CenteringContainer,
    StyledTitle,
    SpaceBetweenContainer,
    DescriptionContainer,
    DescriptionText,
} from "./printReport.styled";
import { getHttpResponse } from "@/api/helper";
import { AppContext } from "@/contexts/AppContext";
import logoFripickBlack from "@/assets/logoFripickBlack.svg";
import graciasCompra from "@/assets/graciasCompra.svg";
import amountToFixed from "@/helper/amountToFixed";
import { parseAmount } from "@/helper/parseAmount";

export default function PrintReport({ setAlert, receiptUrl, handleClose }) {
    const { userId, token } = useContext(AppContext);
    const [receipt, setReceipt] = useState();
    const [print, setPrint] = useState(false);
    const balance = receipt?.balance ?? 0;
    const fetchReceipt = async (receiptUrl) => {
        try {
            const response = await getHttpResponse(`order-report-service/receipt/${receiptUrl}`, token, userId);
            setReceipt(response.data?.success);
        } catch (error) {
            setAlert({
                open: true,
                severity: "error",
                message: error?.message || "Ocurrió un error buscando los datos del reporte",
                duration: 3000,
            });
            handleClose();
        }
    };

    useEffect(() => {
        fetchReceipt(receiptUrl);
    }, []);

    useEffect(() => {
        setPrint(!!receipt);
    }, [receipt]);

    useEffect(() => {
        if (print) {
            setTimeout(() => {
                window.print();
                handleClose();
            }, 20);
        }
    }, [print]);

    const hasDetailsWithDiscount = receipt?.details?.some((detail) => (detail?.discountValue ?? 0) > 0);

    return (
        <MainContainer>
            {receipt && (
                <>
                    <CenteringContainer>
                        <StyledTitle>CONDUCE</StyledTitle>
                    </CenteringContainer>

                    <DescriptionContainer>
                        <DescriptionText>
                            <div>Proveedor:</div>
                            <div>{receipt.providerName}</div>
                        </DescriptionText>
                        <DescriptionText>
                            <div>Empresa:</div>
                            <div>{receipt.companyName}</div>
                        </DescriptionText>
                        <SpaceBetweenContainer>
                            <DescriptionText>
                                <div>Fecha:</div>
                                <div>{receipt.orderDate}</div>
                            </DescriptionText>
                            <DescriptionText>
                                <div>Hora:</div>
                                <div>{receipt.orderTime}</div>
                            </DescriptionText>
                        </SpaceBetweenContainer>
                        <DescriptionText>
                            <div>Nombre Empleado:</div>
                            <div>{receipt.employeeName}</div>
                        </DescriptionText>
                        <DescriptionText>
                            <div>Código Empleado:</div>
                            <div>{receipt.employeeCode}</div>
                        </DescriptionText>
                        <DescriptionText>
                            <div>{`No. de Orden: ${receipt.orderNumber}`}</div>
                            <div></div>
                        </DescriptionText>
                    </DescriptionContainer>

                    <TableContainer>
                        <TableFlexContainer>
                            <LeftFlexGrow>
                                <BoldDescriptionText>DESCRIPCIÓN</BoldDescriptionText>
                            </LeftFlexGrow>
                            {hasDetailsWithDiscount ? (
                                <>
                                    <LeftFlexGrow>
                                        <BoldDescriptionText>CANTIDAD</BoldDescriptionText>
                                    </LeftFlexGrow>
                                    <LeftFlexGrow>
                                        <BoldDescriptionText>PROMOCIÓN</BoldDescriptionText>
                                    </LeftFlexGrow>
                                    <LeftFlexGrow>
                                        <BoldDescriptionText>SUBTOTAL PRE DESCUENTO</BoldDescriptionText>
                                    </LeftFlexGrow>
                                    <LeftFlexGrow>
                                        <BoldDescriptionText>DESCUENTO</BoldDescriptionText>
                                    </LeftFlexGrow>
                                </>
                            ) : (
                                <MiddleFlexGrow>
                                    <BoldDescriptionText>CANTIDAD</BoldDescriptionText>
                                </MiddleFlexGrow>
                            )}

                            <RightFlexGrow>
                                <BoldDescriptionText>VALOR</BoldDescriptionText>
                            </RightFlexGrow>
                        </TableFlexContainer>

                        {receipt.details?.map((detail) => (
                            <TableFlexContainer key={detail.itemName}>
                                <LeftFlexGrow>
                                    <DescriptionText>{detail.itemName}</DescriptionText>
                                </LeftFlexGrow>

                                {detail.discountValue > 0 ? (
                                    <>
                                        <LeftFlexGrow>
                                            <DescriptionText>{detail.itemQuantity}</DescriptionText>
                                        </LeftFlexGrow>
                                        <LeftFlexGrow>
                                            <DescriptionText>{detail.appliedPromo}</DescriptionText>
                                        </LeftFlexGrow>
                                         <LeftFlexGrow>
                                            <DescriptionText>{`RD$ ${amountToFixed(parseAmount(detail.itemValue), 2)}`}</DescriptionText>
                                        </LeftFlexGrow>
                                        <LeftFlexGrow>
                                            <DescriptionText>{`RD$ ${amountToFixed(parseAmount(detail.discountValue), 2)}`}</DescriptionText>
                                        </LeftFlexGrow>
                                       
                                    </>
                                ) : (
                                    <MiddleFlexGrow>
                                        <DescriptionText>{detail.itemQuantity}</DescriptionText>
                                    </MiddleFlexGrow>
                                )}

                                <RightFlexGrow>
                                    <DescriptionText>{`RD$ ${amountToFixed(detail.discountValue ? detail.total : detail.itemValue, 2)}`}</DescriptionText>
                                </RightFlexGrow>
                            </TableFlexContainer>
                        ))}
                    </TableContainer>

                    <DescriptionContainer>
                        {receipt.items?.map((item) => (
                            <SpaceBetweenContainer key={item.itemName}>
                                <DescriptionText isBold={item.itemName === "Total"}>
                                    <div>{item.itemName}</div>
                                </DescriptionText>
                                <DescriptionText>
                                    <div>{item.itemValue}</div>
                                </DescriptionText>
                            </SpaceBetweenContainer>
                        ))}
                    </DescriptionContainer>

                    <BottomCenteringContainer>
                        <strong>
                            <DescriptionText>{`Balance Consumido: RD$ ${amountToFixed(balance, 2)}`}</DescriptionText>
                        </strong>
                        <DescriptionText>{`Representante: ${receipt.vendorName}`}</DescriptionText>
                        <Logo src={logoFripickBlack} />
                        <ThanksImg src={graciasCompra} />
                    </BottomCenteringContainer>
                </>
            )}
        </MainContainer>
    );
}
